import React from "react";

export const useTrackEvent = () => {
  return React.useCallback((contentType: string) => {
    if (window.gtag) {
      window.gtag("event", "select_content", { event_label: contentType });
    }
  }, []);
};
